exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.image-selector .v-input--selection-controls__input {\n    position: absolute;\n    top: 5px;\n    left: 5px;\n    padding: 0 0 0 2px;\n    z-index: 10;\n    background-color: white;\n}\n.image-selector .v-messages {\n    display: none;\n}\n.image-selector .v-input__control {\n    width: 100%;\n}\n.image-selector .v-label {\n    width: 100%;\n}\n.media-name {\n    word-break: break-all;\n}\n", ""]);

// exports
